<template>
  <div>
    <div>
      <table class="table">
        <tr>
          <th>{{ $t("unit.disable_comment") }}</th>
          <td>{{ deactivation_data.comment || " - " }}</td>
        </tr>
        <tr>
          <th>{{ $t("unit.deactivation_date") }}</th>
          <td>{{ deactivation_data.desactivation_date }}</td>
        </tr>
        <tr>
          <th>{{ $t("unit.reactivation_date") }}</th>
          <td>{{ deactivation_data.reactivation_date }}</td>
        </tr>
        <tr>
          <th>{{ $t("unit_deactivation_catalog.deactivation_reason") }}</th>
          <td>{{ deactivation_data.deactivation_catalog.name }}</td>
        </tr>
        <tr v-if="deactivation_data.user_reactivation">
          <th>{{ $t("unit_deactivation_catalog.user_reactivation") }}</th>
          <td>{{ deactivation_data.user_reactivation.email }}</td>
        </tr>
        <tr v-if="deactivation_data.user_deactivation">
          <th>{{ $t("unit_deactivation_catalog.user_deactivation") }}</th>
          <td>{{ deactivation_data.user_deactivation.email }}</td>
        </tr>
      </table>
      <h5 class="ml-1 mt-1">{{ $t("unit_deactivation_catalog.attachments") }}</h5>
      <div v-if="deactivation_data.attachments.length > 0" class="mt-2">
        <b-card
          v-for="(file, index) in deactivation_data.attachments"
          :key="index"
          class="mb-2"
          no-body
        >
          <b-card-body class="p-2">
            <div class="d-flex align-items-center">
              <!-- Preview/Icon -->
              <div class="mr-2">
                <img
                  v-if="file.preview"
                  :src="file.preview"
                  alt="preview"
                  class="file-preview-img"
                />
                <feather-icon v-else icon="FileTextIcon" size="32" class="text-danger" />
              </div>

              <!-- File Info -->
              <div class="flex-grow-1">
                <div class="font-weight-bold">{{ file.name }}</div>
                <small class="text-muted">
                  {{ formatFileSize(file.size) }}
                </small>
              </div>

              <!-- Actions -->
              <div>
                <b-button
                  v-if="file.path"
                  variant="outline-primary"
                  size="sm"
                  class="mr-1"
                  @click="downloadFile(file)"
                >
                  <feather-icon icon="DownloadIcon" size="16" />
                </b-button>
                <b-button variant="outline-danger" size="sm" @click="removeFile(index)">
                  <feather-icon icon="TrashIcon" size="16" />
                </b-button>
              </div>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { BSpinner } from "bootstrap-vue";

export default {
  props: {
    deactivation_data: Object,
  },
  components: {
    BSpinner,
  },
  setup() {
    const formatFileSize = (bytes) => {
      if (bytes === 0) return "0 Bytes";
      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + " " + sizes[i];
    };

    return { formatFileSize };
  },
};
</script>

<style></style>
